import LinkWithIcon from "./LinkWithIcon";
import { getLegAirport, getLegTerminal } from "../../utilities/flightBriefLegUtils";

const renderTerminalInfo = (airport, terminal, date) => {
    if (!airport || !terminal) return null;

    return (
        <div>
            <div className="flight-brief__item">
                <div className="flight-brief__gold-title">
                    {airport.name} - {date}
                </div>
                <div className="flight-brief__dark-title">{terminal.name}</div>
                {terminal.tel_Number === "TBC" ? (
                    <LinkWithIcon icon="phone">TBC</LinkWithIcon>
                ) : (
                    <LinkWithIcon link={`tel:${terminal.tel_Number}`} icon="phone">
                        {terminal.tel_Number}
                    </LinkWithIcon>
                )}
            </div>

            <div className="flight-brief__item">
                <div className="flight-brief__body-text--light">Address: </div>
                {terminal.address_Line_1 === "TBC" ? (
                    <span>TBC</span>
                ) : (
                    <div className="flight-brief__body-text--dark">
                        {terminal.address_Line_1} {terminal.address_Line_2}, {terminal.postcode}
                    </div>
                )}
            </div>

            <div className="flight-brief__item">
                <div className="flight-brief__body-text--light">
                    What3Words: <span className="flight-brief__body-text--w3w">{"///"} </span>
                    {terminal.what_three_words === "TBC" ? (
                        <span>TBC</span>
                    ) : (
                        <a
                            className="flight-brief__body-text--link"
                            href={"https://w3w.co/" + terminal.what_three_words}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {terminal.what_three_words}
                        </a>
                    )}
                </div>
            </div>

            <div className="flight-brief__item">
                Directions to airport:&nbsp;
                {terminal.longitude_and_Latitude === "TBC" ? (
                    <span>TBC</span>
                ) : (
                    <a
                        className="flight-brief__body-text--link"
                        href={"https://maps.google.com?q=" + terminal.longitude_and_Latitude}
                        target="_blank"
                        rel="noreferrer"
                    >
                        view on Google Maps
                    </a>
                )}
            </div>
        </div>
    );
};

const FlightBriefAirportInformation = ({ briefData }) => {
    if (!briefData.legs || briefData.legs.length === 0) return null;

    return (
        <>
            {briefData.legs.map((leg, legIndex) => {
                const departureAirport = getLegAirport(briefData, legIndex, "departure");
                const departureTerminal = getLegTerminal(briefData, legIndex, "departure");
                const arrivalAirport = getLegAirport(briefData, legIndex, "arrival");
                const arrivalTerminal = getLegTerminal(briefData, legIndex, "arrival");

                return (
                    <div key={legIndex} className="flight-brief__content-grid flight-brief__airport-leg">
                        {renderTerminalInfo(departureAirport, departureTerminal, leg.departureDate)}
                        {renderTerminalInfo(arrivalAirport, arrivalTerminal, leg.arrivalDate)}
                    </div>
                );
            })}
        </>
    );
};

export default FlightBriefAirportInformation;
